import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class SubscriptionSettings extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "SubscriptionSettings";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (data.labels && data.labels.typeFilter) store.state.config.billing.schedule.labels.typeFilter = data.labels.typeFilter
    if (data.labels && data.labels.statusFilter) store.state.config.billing.schedule.labels.statusFilter = data.labels.statusFilter
    if (data.labels && data.labels.paymentTypeFilter) store.state.config.billing.schedule.labels.paymentTypeFilter = data.labels.paymentTypeFilter
    if (data.labels && data.labels.dueDate) store.state.config.billing.schedule.labels.dueDate = data.labels.dueDate
    if (data.labels && data.labels.listTitle) store.state.config.billing.schedule.labels.listTitle = data.labels.listTitle
    if (data.labels && data.labels.paymentListTitle) store.state.config.billing.schedule.labels.paymentListTitle = data.labels.paymentListTitle
    if (data.labels && data.labels.selectStatus) store.state.config.billing.schedule.labels.selectStatus = data.labels.selectStatus
    if (data.labels && data.labels.sendEmailTitle) store.state.config.billing.schedule.labels.sendEmailTitle = data.labels.sendEmailTitle

    return data;
  }
}
